// store/modules/guidanceStore.js
import { ServiceRecords } from '@/service/records/serviceRecords'

const serviceRecords = new ServiceRecords()

export default {
  namespaced: true,
  state: {
    guidance: {
      guidance_text: '',
    },
  },
  getters: {
    getGuidance(state) {
      return state.guidance
    },
  },
  mutations: {
    setGuidance(state, data) {
      state.guidance = data
    },
    updateGuidanceField(state, { field, value }) {
      state.guidance[field] = value
    },
  },
  actions: {
    async saveGuidance({ commit }, { recordId, data }) {
      const payload = {
        guidance: data.guidance_text,
      }
      const response = await serviceRecords.recordUpdate(recordId, payload)
      commit('setGuidance', {
        guidance_text: response.data.guidance,
      })
    },
    async loadGuidance({ commit }, recordId) {
      const response = await serviceRecords.recordById(recordId)
      const data = {
        guidance_text: response.guidance,
      }
      commit('setGuidance', data)
      return data
    },
  },
}
